import React, { createContext } from "react";

import "./CompanyPage.css";

import Header from "../components/Header/Header";
import About from "../components/About/About";
import Partners from "../components/Partners/Partners";
// import Questions from "../components/Questions/Questions";
import Footer from "../components/Footer/Footer";

function Company() {
  return (
    <div className="company">
      <Header covermode="Company"/>
      <div className="body">
        <About />
        <Partners />
        {/* <Questions /> */}
      </div>
      <Footer />
    </div>
  );
}

export default Company;
